export default __webpack_public_path__ + "static/media/studio_photography.5727ae0d.jpg";